import styles from './NewAgentTaskForm.module.css'
import {
  NewTaskChatInput,
  type NewTaskChatInputProps,
  type CreateTaskReference,
  // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
} from '@github-ui/agent-sessions/components/new-task-chat-input/NewTaskChatInput'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import type {DropdownRepository} from '@github-ui/agent-sessions/hooks/useCopilotRepoFetching'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {CopilotChatProvider} from '@github-ui/copilot-chat/CopilotChatContext'
/* eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports --
   preexisting violation https://github.com/github/react-platform/issues/1135 */
import {relayEnvironmentWithMissingFieldHandlerForNode} from '@github-ui/relay-environment'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {RelayEnvironmentProvider} from 'react-relay'
import {SkeletonBox} from '@primer/react'
import {useCurrentRepository, type Repository} from '@github-ui/current-repository'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {uuid} from '@github-ui/agent-sessions/utils/uuid'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {useCopilotChatPayloadQuery} from '@github-ui/global-copilot-menu/hooks/useCopilotChatPayloadQuery'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import type {CreateTaskParams} from '@github-ui/agent-sessions/types/task'

const environment = relayEnvironmentWithMissingFieldHandlerForNode()

export type NewAgentTaskFormProps = {
  createTask: (task: CreateTaskParams) => void
  currentRepo?: Repository
  currentReference?: CreateTaskReference
  onCreate?: () => void
  showHeader?: boolean
  hideRepoSelector?: boolean
  eventType: string
  isInPortal?: NewTaskChatInputProps['isInPortal']
  textAreaRef?: NewTaskChatInputProps['textAreaRef']
}

export function NewAgentTaskForm({
  createTask,
  currentRepo,
  currentReference,
  onCreate,
  showHeader = true,
  hideRepoSelector,
  eventType,
  isInPortal,
  textAreaRef,
}: NewAgentTaskFormProps) {
  const copilotChatPayload = useCopilotChatPayloadQuery()
  const currentRepoFromContext = useCurrentRepository()
  const initialRepo = currentRepo || currentRepoFromContext

  const handleUserSubmit = async (
    content: string,
    selectedRepo: DropdownRepository | null,
    selectedBranch: string,
    selectedCustomAgent: string,
    reference?: string,
  ) => {
    const trimmedContent = content.trim()
    if (trimmedContent === '') return
    if (!selectedRepo) return
    const newTask = {
      id: uuid(),
      nwo: selectedRepo.nameWithOwner,
      problemStatement: trimmedContent,
      baseRef: selectedBranch || selectedRepo.defaultBranch,
      reference,
      eventType,
      eventContent: trimmedContent,
      customAgent: selectedCustomAgent,
    }
    createTask(newTask)

    onCreate?.()
  }

  return (
    <>
      {showHeader && (
        <div className={styles.header}>
          <h2 className="f5">New agent task</h2>
        </div>
      )}
      <div className={`${styles.content} ${showHeader ? '' : 'pt-3'}`}>
        {copilotChatPayload ? (
          <RelayEnvironmentProvider environment={environment}>
            <CopilotChatProvider
              workerPath={copilotChatPayload.findFileWorkerPath}
              threadId={null}
              refs={copilotChatPayload.refs || []}
              mode="immersive"
              ssoOrganizations={copilotChatPayload.ssoOrganizations || []}
              copilotChatPayload={copilotChatPayload}
            >
              <NewTaskChatInput
                handleUserSubmit={handleUserSubmit}
                initialRepo={initialRepo}
                initialReference={currentReference}
                hideRepoSelector={hideRepoSelector}
                isInPortal={isInPortal}
                textAreaRef={textAreaRef}
              />
            </CopilotChatProvider>
          </RelayEnvironmentProvider>
        ) : (
          <SkeletonBox className={styles.skeleton} />
        )}
      </div>
    </>
  )
}

try{ NewAgentTaskForm.displayName ||= 'NewAgentTaskForm' } catch {}